import { fetchJson } from "../lib/api";

export type PriceAnomalyComparisonBasis =
  | "prior_12m_fallback"
  | "prior_24m_fallback"
  | "prior_all_history";

export type PriceAnomalyRuleSnapshot = {
  revision: number;
  comparison_basis: PriceAnomalyComparisonBasis;
  threshold_pct: string;
  minimum_reference_count: number;
  minimum_overpay_abs: string | null;
  updated_at: string | null;
};

export type PriceAnomalyRuleResponse = {
  configured: PriceAnomalyRuleSnapshot;
  effective: PriceAnomalyRuleSnapshot;
  refresh_pending: boolean;
  reference_counts_available?: boolean;
  can_manage: boolean;
  activation: "next_regular_refresh";
};

export type PriceAnomalyRuleUpdate = {
  request_id: string;
  expected_revision: number;
  comparison_basis: PriceAnomalyComparisonBasis;
  threshold_pct: number;
  minimum_reference_count: number;
  minimum_overpay_abs: number | null;
};

export function fetchPriceAnomalyRule(): Promise<PriceAnomalyRuleResponse> {
  return fetchJson<PriceAnomalyRuleResponse>("/api/price-anomaly-rule");
}

export function updatePriceAnomalyRule(
  body: PriceAnomalyRuleUpdate,
): Promise<PriceAnomalyRuleResponse> {
  return fetchJson<PriceAnomalyRuleResponse>("/api/price-anomaly-rule", {
    method: "PUT",
    body: JSON.stringify(body),
  });
}
